import styled from 'styled-components';
import { Text } from '../Text/Text';
/**
 * @public
 */
export const Truncate = /*#__PURE__*/styled(Text).withConfig({
  displayName: "Truncate",
  componentId: "sc-1q95e1k-0"
})(["overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);
Truncate.displayName = 'Truncate';